import { withDomains, RESTExecutor } from '../../../lib/domain'
import { Spin, Row, Input, Button, Select, message } from 'antd';
import { showErrorInNotification, copyStringToClipboard } from '../../../lib/util';
import React, {Component} from 'react';
import Form from '../../../lib/ui/form';
import Title from 'antd/lib/typography/Title';


const normalizer_field=[
    {
        index:'normalizer_config',
        name:"Normalizer  Config",
        type:'json'
    },
    {
        index:'balance_normalizer_config',
        name:"Balance Normalizer  Config",
        type:'json'
    }
]

const normalizer=[
    {index:'amount',name:'Amount',type:'text',required:true},
    {index:'description',name:'Description',type:'text',required:true},
    {index:'source_id',name:'Source ID',type:'text',required:true},
    {index:'transaction_id',name:'Transaction ID',type:'text'},
    {index:'txn_date',name:'Transaction Date',type:'text',required:true},
    {index:'type',name:'Type',type:'text',required:true},
    {index:'reconcile',name:'Reconcile Expression',type:'text',required:true}
]

const balance_normalizer=[
    {index:'opening_balance',name:"Opening Balance",type:'text'},
    {index:'closing_balance',name:"Closing Balance",type:'text'}
]
class PipelineNormalizer extends Component {
    constructor(props) {
        super(props)

        const { normalizer_config,balance_normalizer_config} = this.props.pipeline_data;
        this.state = {
            pipeline_data: { normalizer_config ,balance_normalizer_config},
            reference_normalizer:{}

        };
        this.pipeline_id = this.props.pipeline_id;
        this.datatype_id=this.props.datatype_id;
        this.has_changed=false;

        this.patch_pipeline=RESTExecutor.patch().config({
            label:'pipeline_detail',
            params:{
                datatype_id:"",
                pipeline_id:""
            }
        }).callbacks((success)=>{
            message.success("Updated Successfully")
            typeof this.props.onPipelineChange==='function' &&  this.props.onPipelineChange()
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.datatype);

        this.list_references_normalizer = RESTExecutor.list().config({
            label: 'list',
            params: {
                type: "NORMALIZER"
            }
        }).callbacks((success) => {
            let reference_normalizer = this.state.reference_normalizer;
            success.result.rows.map((item) => {
                reference_normalizer[item.id] = item;
            });
            this.setState({
                reference_normalizer: reference_normalizer
            });
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.references);
        
        this.list_references_normalizer.execute()
    };


    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed=true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

     render() {

        if (!this.props.pipeline_id) {
            return <Spin />
        }

        let patch_pipeline_resp=this.patch_pipeline.response();

        const { pipeline_data } = this.state;
        let formatted_normalizer = pipeline_data.normalizer_config || "";
        if (typeof pipeline_data.normalizer_config === 'object') {
            formatted_normalizer = JSON.stringify(pipeline_data.normalizer_config, null, 4);
        }
        return (
            <div>

<br></br>
                    <center><Button onClick={() => {
                        this.setState({
                            showReferencesNormalizer: !this.state.showReferencesNormalizer
                        })
                    }} type='link' icon={this.state.showReferencesNormalizer ? 'caret-up' : 'caret-down'}>{
                            this.state.showReferencesNormalizer ? "Hide Reference" : "Use Reference"
                        }</Button></center>
                    {this.state.showReferencesNormalizer &&
                        <center> <span>Reference: &nbsp; <Select placeholder={"Reference"} style={{
                            width: 300
                        }}
                            //   value={pipeline_data.parser_id}
                            showSearch
                            filterOption={(input, option) => {
                                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            onSearch={(value) => {
                                console.log(value)
                                this.list_references_normalizer.config({
                                    params: {
                                        type: "NORMALIZER",
                                        query: value
                                    }
                                }).execute()
                            }}
                            onChange={(value) => {
                                // console.log("parser id", value, this.state.parsers[value]);

                                //   this.stateUpdater({ stateKey: 'pipeline_data', valueKey: 'parser_id', value: value })
                                this.stateUpdater({
                                    stateKey: 'pipeline_data', valueKey: 'normalizer_config', value:
                                        (this.state.reference_normalizer[value] && this.state.reference_normalizer[value].config) || {}
                                })

                                //   this.setState({
                                //       schema: schema_to_field(this.state.parsers[value].validation_config),
                                //       selectedParser: this.state.parsers[value].name
                                //   })
                            }}
                        >
                            {Object.keys(this.state.reference_normalizer).map((key, index) => {

                                let dataItem = this.state.reference_normalizer[key] || {}
                                return <Select.Option value={dataItem.id} key={dataItem.id}>
                                    {dataItem.name}
                                </Select.Option>
                            })}
                        </Select>
                        </span></center>}
                <div style={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'space-between',
            }}>
                <Row type='flex' justify='space-between'>
                <Title level={4} >Normalizer Config</Title>
                <Button size='small' icon='plus' type='primary' className='export-btn' onClick={()=>{
                copyStringToClipboard(JSON.stringify(pipeline_data.normalizer_config||{}));
                message.success("Copied")
            }}>Copy To Clipboard</Button>
                </Row>
                <Form
              hideTitle
              forCreate={true}
              initialData={pipeline_data.normalizer_config || {}}
              submitted={this.state.submitted}
              onChange={(data) => {
                  console.log("Changes", data);
                  this.has_changed=true;
                  this.stateUpdater({
                      stateKey:'pipeline_data',
                      valueKey:'normalizer_config',
                      value:data
                  })

                //   this.setState({pipeline_data:data})
              }}
              fields={normalizer}
              submitting={{}}
              errorMessage={{}}
              validationErrors={{}}
          />
          <br></br>
            <Title level={4} >Balance Normalizer Config</Title>
                <Form
              hideTitle
              forCreate={true}
              initialData={pipeline_data.balance_normalizer_config || {}}
              submitted={this.state.submitted}
              onChange={(data) => {
                  console.log("Changes", data);
                  this.has_changed=true;
                  this.stateUpdater({
                      stateKey:'pipeline_data',
                      valueKey:'balance_normalizer_config',
                      value:data
                  })

                //   this.setState({pipeline_data:data})
              }}
              fields={balance_normalizer}
              submitting={{}}
              errorMessage={{}}
              validationErrors={{}}
          />
                <br></br>
                <br></br>
                <Row type='flex' justify='space-between'>
                    <div></div>
                    <div><Button type='primary'
                    disabled={!this.has_changed || patch_pipeline_resp.fetching}
                    loading={patch_pipeline_resp.fetching}
                    onClick={()=>{
                        this.patch_pipeline.config({
                            params:{
                                datatype_id:this.datatype_id,
                                pipeline_id:this.pipeline_id
                            }
                        }).execute(pipeline_data)
                    }}
                    >Submit</Button></div>
                </Row>
                </div>
            </div>
        )
    }
    componentDidUpdate = (prevProps) => {
        if (this.props.pipeline_id !== prevProps.pipeline_id||
            this.props.datatype_id !== prevProps.datatype_id||
            this.props.pipeline_data !== prevProps.pipeline_data) {
            // console.log("props change",this.props)
            this.pipeline_id = this.props.pipeline_id;
            this.datatype_id=this.props.datatype_id;
            this.patch_pipeline.forId(this.pipeline_id);
            let { normalizer_config} = this.props.pipeline_data;
            // console.log("name",name)
            this.setState({
                pipeline_data: { normalizer_config}
            });

            // fetch the new product based and set it to the state of the component
        };
    }
}

export default withDomains(PipelineNormalizer,"datatype","references");
